// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
var _ = require('lodash');
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import {
  unloadDashboard, searchSuggestions, navActivate,
  selectIndex, showUtilization
} from '../../actions/actions';
import { addSubscription } from '../../actions/locationView';
import constants from '../../Constants';
import { roundOffDecimals } from '../../utils/Utility';
import {StripeProvider} from 'react-stripe-elements';
import {Elements} from 'react-stripe-elements';
import Header from 'grommet/components/Header';
import Headline from 'grommet/components/Headline';
import Tile from 'grommet/components/Tile';
import Button from 'grommet/components/Button';
import Heading from 'grommet/components/Heading';
import Card from 'grommet/components/Card';
import Tiles from 'grommet/components/Tiles';

import NavControl from '../NavControl';

import { navEnable } from '../../actions/nav';
import { showLoader } from '../../actions/status';
import ConfirmSubscription from './ConfirmSubscription';

class LocationView extends Component {

  constructor(props) {
    super(props);
    this.renderPlanDetails = this.renderPlanDetails.bind(this);
    this.renderSubscriptionTiles = this.renderSubscriptionTiles. bind(this);
    this.addSubscription = this.addSubscription.bind(this);

  }

  componentWillMount() {
    this.props.dispatch(navEnable(true));
  }


  componentDidMount() {
    this.props.dispatch(showLoader(false));
  }

  componentWillReceiveProps(nextProps) {

  }

  componentDidUpdate() {

  }

  componentWillUnmount() {

  }

  addSubscription(plan) {
    let togglesubscriptionForm = !this.props.showSubscriptionForm;
    return () => {
      this.props.dispatch(addSubscription({togglesubscriptionForm, plan}));
    }
  }

  renderPlanDetails(plan){
    return (
      <div className="tile-header-container">
        <h3 className="heading">{plan.name}</h3>
        <div className="price-content">
          <div className="plan-price"> ${roundOffDecimals(plan.amount/100, 2)}</div>
          <div className="plan-duration">per<br/>
          {plan.interval_count > 1 ? <span>{plan.interval_count} </span> : ''}
          {plan.interval}</div>
        </div>
      </div>
    )
  }

  renderDummyPlanDetails(){
    return (
      <div className="tile-header-container">
        <h3 className="heading">Enterprise Plan</h3>
        <div className="price-content">
          <div className="plan-price">Volume Discount</div>
        </div>
      </div>
    )
  }

  getPlanFeatures(plan) {
    const styles = {

    }
    let featureList = [];
    if(plan && plan.metadata && Object.keys(plan.metadata).length > 0){
      for (var key in plan.metadata){
        featureList.push(
          <li key={plan.id + "_" + key}>
            <span>{plan.metadata[key]}</span>
          </li>
        )
      }
      return (
        <ul className="plan-features">
          {featureList}
        </ul>
      )
    }
    else {
      return (<h4 className="plan-features">No feature list</h4>);
    }

  }

  getDummyPlanFeatures() {
    const styles = {

    }
    let featureList = [];
    featureList.push(
      <li key={"0_0"}>
        <span>For more than 10 Stems</span>
      </li>
    )
    featureList.push(
      <li key={"0_1"}>
        <span>Contact sales@gro.guru</span>
      </li>
    )
    featureList.push(
      <li key={"0_2"}>
        <span>or Call to us at +1-559-461-5705</span>
      </li>
    )
    return (
      <ul className="plan-features">
        {featureList}
      </ul>
    )
  }


  renderSubscriptionTiles() {
    let subscriptionTiles =[];
    if(this.props.stripePlans) {
      _.forEach(this.props.stripePlans.data, (plan)=> {
        subscriptionTiles.push(
          <Tile key={plan.id}>
          <Card heading= {this.renderPlanDetails(plan)}
            link={<div className="add-subscription-button">
              <Button label='Add'
              className='lighter-font'
              onClick={this.addSubscription(plan)}
              primary={true}
              secondary={false}
              accent={false} />
            </div>}
            description={this.getPlanFeatures(plan)} />
        </Tile>
        )
      });

      // dummy plan
      let plan = {
        id : '0',

      }
      subscriptionTiles.push(
        <Tile key={plan.id}>
          <Card heading= {this.renderDummyPlanDetails()}

                description={this.getDummyPlanFeatures()} />
        </Tile>
      )
    }
    return subscriptionTiles;
  }

  render() {
    let optionStyle = {
      color: 'black'
    }

    return (
      <StripeProvider apiKey={this.props.stripeAPIKey}>
        <div className="subscription-container">
          <div style={{ display: this.props.showSubscriptionForm ? 'none' : '' }}>
            <h3 className="heading">Add/Change Subscription Plan for stem {this.props.selectedTwig.name}/{this.props.selectedTwig.twigId}</h3>
            <Tiles fill={false}
                flush={false}>
              {this.renderSubscriptionTiles()}
            </Tiles>
          </div>
          <div style={{ display: !this.props.showSubscriptionForm ? 'none' : '' }}>
            <Elements>
              <ConfirmSubscription />
            </Elements>
          </div>
        </div>
      </StripeProvider>
    );
  }

}

LocationView.propTypes = {
  twigsList: PropTypes.array,
  search: PropTypes.object
};

let select = (state, props) => ({
  selectedTwig: state.locationView.selectedTwig,
  selectedTwigIndex : state.locationView.selectedTwigIndex,
  stripePlans: state.locationView.stripePlans,
  showSubscriptionForm : state.locationView.showSubscriptionForm,
  rememberMeCardData : state.locationView.rememberMeCardData,
  savedCard : state.locationView.savedCard,
  stripeAPIKey: state.session.stripeAPIKey
});

export default connect(select)(LocationView);



// WEBPACK FOOTER //
// ./src/js/components/location/Plans.js